import React from 'react';

import { ActionsMenu, ButtonWithForwardedRef as Button, Icon } from '@neptune/shared/venus-ui';

type Props = {
  children: React.ReactNode;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
};

export const DetailsDropdownMenu = ({ children, open, onOpenChange }: Props) => {
  return (
    <ActionsMenu open={open} onOpenChange={onOpenChange}>
      <ActionsMenu.Trigger asChild>
        <Button square data-role="details-menu-button" variant="transparent" size="lg">
          <Icon glyph="dots-horizontal" />
        </Button>
      </ActionsMenu.Trigger>
      <ActionsMenu.Portal>{children}</ActionsMenu.Portal>
    </ActionsMenu>
  );
};
